<template>
  <div class="npc-action">
    <character-select
      :selected="state.characterKey"
      :characters="getSourceCharacters(emitter.caseConf)"
      :disabled="readonly"
      :errors="missingSourceCharacterErrors"
      placeholder="Select Source Character"
      @input="updateCharacter"
    />
    <dialogue-action
      :action-type="state.type"
      placeholder="Question"
      :get-dialogue-items="getSelectedCharacterItems"
      :put-data="putDataWithNpcData"
      v-bind="$props"
    />
  </div>
</template>

<script>
import get from 'lodash/get';
import CharacterSelect from './CharacterSelect.vue';
import DialogueAction from './DialogueAction.vue';
import nodeMixins from './mixins/NodeMixins';
import { getSourceCharacters } from '~lib/common/utils/characters';
import { getDialogueItemsForCharacter } from '~lib/common/utils/dialogue';
import { isNpc } from '~lib/common/utils/npc';

export default {
  name: 'npc-action',
  components: {
    CharacterSelect,
    DialogueAction,
  },
  mixins: [ nodeMixins ],
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        characterKey: null,
        type: null,
        id: null,
        confidence: null,
        type: 'AI_QUESTION'
      },
    };
  },
  computed: {
    missingSourceCharacterErrors() {
      return this.getErrorsById('missingSourceCharacter');
    },
    missingQuestionErrors() {
      return this.getErrorsById('missingQuestion');
    },
  },
  created() {
    const data = this.getData(this.ikey);
    this.state.characterKey = get(data, 'characterKey') || 'patient';
    this.state.type = get(data, 'type') || 'AI_QUESTION';
    this.state.id = get(data, 'id');
    this.state.confidence = get(data, 'confidence');
  },
  mounted() {
    this.emitter.trigger('process', this.control);
  },
  methods: {
    updateCharacter(key) {
      this.state.characterKey = key;
      this.putDataWithNpcData(this.ikey, {});
    },
    putDataWithNpcData(key, data) {
      if (isNpc(this.state.characterKey)) {
        this.state.type = 'NPC_AI_QUESTION';
      } else {
        this.state.type = 'AI_QUESTION';
      }
      this.putData(key, {
        ...data,
        type: this.state.type,
        characterKey: this.state.characterKey,
      });
      this.emitter.trigger('process', this.control);
    },
    getSelectedCharacterItems() {
      return getDialogueItemsForCharacter(this.emitter.caseConf, this.state.characterKey, 'aiQuestions');
    },
    getSourceCharacters,
  },
};
</script>

<style scoped>
</style>